import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SendIcon from "@mui/icons-material/Send";

import { handlePreviewFont } from "../helpers";
import images from "../../../global-styles/images";

import "../styles.css";
import PlayGroundChat from "../../../routes/playground-chat";
import PlayGroundChatPreview from "./PlayGroundChatPreview";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
interface IProps {
  chatbotSettings: any;
  chatbotAppearance: any;
}

const PlaygroundPreview = (props: any) => {
  const {
    productParams,
    ChatSessionuuid,
    show,
    chatbotAppearance,
    chatbotSettings,
    wcmsg,
    showAlertForPrevPlayground,
  } = props;
  // console.log(productParams, "productParams---");

  const [previewChatbot, setPreviewChatbot] = useState<boolean>(false);

  const handleTogglePreview = () => {
    setPreviewChatbot((prevState) => !prevState);
  };

  return (
    <Box
      style={{
        display: show["AISettings"] || show["preAISettings"] ? "block" : "none",
      }}
    >
      <Typography className="prev-text-titile">Playground</Typography>

      <Typography className="info">
        You can use this playground to test your AI and Pre-AI settings. The
        form displayed here and the ticket raising message is just
        representative of what your customers will see.
      </Typography>

      <Box sx={{ mt: 2 }}>
        {showAlertForPrevPlayground && (
          <Stack sx={{ width: "100%" }} pt={2}>
            <Alert severity="info">
              Please <b>Save</b> the Chat Settings, to see the below Chat
              Playground works!
            </Alert>
          </Stack>
        )}
        <PlayGroundChatPreview
          productParams={productParams}
          ChatSessionuuid={ChatSessionuuid}
          chatbotAppearance={chatbotAppearance}
          chatbotSettings={chatbotSettings}
          wcmsg={wcmsg}
        />
      </Box>
    </Box>
  );
};

export default PlaygroundPreview;
